export default __webpack_public_path__ + "static/media/photo--sm--chris-3.7c7c8b5d.jpg";